module.exports = __webpack_public_path__ + "static/media/jobstats_logo.c321abac.png";